// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* override CRISP styles */
.container {
    max-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/web-component.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,0BAA0B;AAC9B","sourcesContent":["/* override CRISP styles */\n.container {\n    max-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
